var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMissingImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "nonzero",
    d: "M111.333333,112 L119.625068,99.5623984 C121.108794,97.3368091 123.606645,96 126.28147,96 L173.71853,96 C176.393355,96 178.891206,97.3368091 180.374932,99.5623984 L188.666667,112 L202,112 C208.627417,112 214,117.372583 214,124 L214,192 C214,198.627417 208.627417,204 202,204 L98,204 C91.372583,204 86,198.627417 86,192 L86,124 C86,117.372583 91.372583,112 98,112 L111.333333,112 Z M150,188 C167.673112,188 182,173.673112 182,156 C182,138.326888 167.673112,124 150,124 C132.326888,124 118,138.326888 118,156 C118,173.673112 132.326888,188 150,188 Z M150,180 C136.745166,180 126,169.254834 126,156 C126,142.745166 136.745166,132 150,132 C163.254834,132 174,142.745166 174,156 C174,169.254834 163.254834,180 150,180 Z M190,124 C187.790861,124 186,125.790861 186,128 C186,130.209139 187.790861,132 190,132 L198,132 C200.209139,132 202,130.209139 202,128 C202,125.790861 200.209139,124 198,124 L190,124 Z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "rotate(45 49.497 307.28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 250,
    fill: "#FFF",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 250,
    x: 10,
    fill: "#363636",
    rx: 5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissingImage);
export default __webpack_public_path__ + "static/media/icon-missing-image.6f1bc4536ef42eda8894f1aa2cd7c002.svg";
export { ForwardRef as ReactComponent };